// removed by extract-text-webpack-plugin
module.exports = {"link":"MultiSelectInput__link","position-close":"MultiSelectInput__position-close","positionClose":"MultiSelectInput__position-close","input-classes":"MultiSelectInput__input-classes","inputClasses":"MultiSelectInput__input-classes","input-focus-css":"MultiSelectInput__input-focus-css","inputFocusCss":"MultiSelectInput__input-focus-css","tags":"MultiSelectInput__tags","dropdown":"MultiSelectInput__dropdown","icons":"MultiSelectInput__icons","record-not-found":"MultiSelectInput__record-not-found","recordNotFound":"MultiSelectInput__record-not-found"};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/duc/components/atoms/MultiSelectInput/MultiSelectInput.scss
// module id = 1786
// module chunks = 8